import { render } from "./WordListTrial1.vue?vue&type=template&id=33da3d9e&scoped=true"
import script from "./WordListTrial1.vue?vue&type=script&lang=js"
export * from "./WordListTrial1.vue?vue&type=script&lang=js"

import "./WordListTrial1.vue?vue&type=style&index=0&id=33da3d9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33da3d9e"]])

export default __exports__